export const TravelUpsellRoutes = {
  LIST: "/upsells",
  CREATE: "/upsells/new",
  DESTINATIONS: "/upsells/destinations",
  EDIT: "/upsells/:id",
} as const;
